var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-layout',{staticClass:"div_diagnostic-list",attrs:{"column":""}},[_c('v-flex',[_c('DiagnosticTouch',{staticClass:"my-4"})],1),_c('v-flex',[_c('DiagnosticScreen',{staticClass:"my-4"})],1),_c('v-flex',[_c('DiagnosticCamera',{staticClass:"my-4"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }